import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { jwtDecode} from 'jwt-decode'; // Install: npm install jwt-decode

const BASE_URL = process.env.REACT_APP_BASE_URL;
export const login = createAsyncThunk(
  'auth/login',

  async (credentials, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${BASE_URL}/api/login`, credentials);
      return response.data; 
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
export const logoutUser = createAsyncThunk(
  'auth/logout',
  async (_, { getState, rejectWithValue }) => {
    try {
      const state = getState();
      const token = state.auth.token;

      const response = await axios.post(
        `${BASE_URL}/api/logout`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          timeout: 5000,
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const initialUserData = {
  id: null,
  user_name: '',
  user_email: '',
  user_cnic: '',
  user_phone_number: '',
  user_Management_Id: null,
  user_Province_ID: null,
  user_role_id: null,
  user_role_name: '',
  user_status: null,
  user_permissions: []
};

// Helper function to check token expiration
const isTokenExpired = (token) => {
  if (!token) return true;

  try {
    const decoded = jwtDecode(token);
    console.log(decoded , 'decoder');
    
    return decoded.exp * 1000 < Date.now(); 
  } catch (error) {
    console.error('Invalid token:', error.message);
    return true; 
  }
};


const clearSession = (state) => {
  state.user = initialUserData;
  state.token = null;
  state.loading = false;
  state.error = null;
  localStorage.removeItem('token');
};

// Slice
const authSlice = createSlice({
  name: 'auth',
  initialState: {
    user: initialUserData,
    token: null,
    loading: false,
    error: null,
  },
  reducers: {
    logout: (state) => {
      state.user = initialUserData;
      state.token = null;
      state.loading = false;
      state.error = null;
      localStorage.removeItem('token'); // Clear token from storage
    },
    checkTokenExpiration: (state) => {
      if (isTokenExpired(state.token)) {
        state.user = initialUserData;
        state.token = null;
        state.loading = false;
        state.error = 'Session expired. Please log in again.';
        localStorage.removeItem('token'); // Remove token from storage
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(login.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(login.fulfilled, (state, action) => {
        state.loading = false;
        const { data, token } = action.payload;
        state.user = data || initialUserData;
        state.token = token;
        localStorage.setItem('token', token); // Store token in local storage
      })
      .addCase(login.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(logoutUser.fulfilled, clearSession)
      .addCase(logoutUser.rejected, clearSession);


  },
});

export const { logout, checkTokenExpiration } = authSlice.actions;
export default authSlice.reducer;